import { cn } from '@/lib/utils';

function SectionWrapper({
	children,
	className = '',
	heading,
}: {
	children: React.ReactNode;
	className?: string;
	heading?: string;
}) {
	return (
		<section className={cn('mx-auto w-full max-w-screen-sm px-4 py-12', className)}>
			<h2 className="mb-12 text-center">
				<span className="border-ash-800 border-b-2 bg-ash-50">{heading}</span>
			</h2>
			{children}
		</section>
	);
}

export { SectionWrapper };
